import React, { Component } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Card,
  TabsCustom,
  TabsCustomBody,
  TabsCustomHeader,
  TabsCustomItem,
  TabsCustomMenu,
  BarChart,
} from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import * as XLSX from "xlsx";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import GeneralCharts from "./GeneralCharts";
import TableQuality from "./TableQuality";
import TableReparable, { getReparableLabelsList } from "./TableReparable";
import TableUnreparable, { getUnreparableLabelsList } from "./TableUnreparable";
import TablePRE from "./TablePRE";
import TableByExpert from "./TableByExpert";
import TableByAgency from "./TableByAgency";

import { getColors } from "../../../utils/colors";

export class GeneralData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsMenu: [
        "Géneral",
        "Réparables",
        "Non Réparables",
        "Qualité",
        "PRE",
        "Compagnie par Expert",
        "Compagnie par agence",
      ],
      // tabsIndex: 0,
      tabsData: [1, 1, 1, 1, 1, 1, 1],
    };
  }

  componentDidMount = () => {
    if (this.props.dataChart.length === 0 && this.props.tabsIndex === 0) {
      this.setState({ tabsData: [null, 1, 1, 1, 1, 1, 1] });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.isPrint !== this.props.isPrint) {
      setTimeout(
        () =>
          this.setState({ chartLabelsLoaded: this.props.isPrint }, () =>
            this.props.onLabelsLoaded(this.state.chartLabelsLoaded)
          ),
        50
      );
    }
  };

  exportWorkbook = (sheets, fileName) => {
    const workBook = XLSX.utils.book_new();
    sheets.forEach(({ name, rows }) => {
      const sheet = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(workBook, sheet, name.slice(0, 31));
    });
    const stamp = new Date()
      .toISOString()
      .replace(/[-:T]/g, "")
      .slice(0, 14);
    XLSX.writeFile(workBook, `${fileName}_${stamp}.xlsx`);
  };

  handleExportByExpert = () => {
    const experts = this.props.dataByExpert || [];
    if (!experts.length) return;
    const buildRows = (labels, datasetKey) =>
      experts
        .filter((expert) => {
          const src =
            expert.dataGeneral &&
            expert.dataGeneral[datasetKey] &&
            expert.dataGeneral[datasetKey][1];
          return src && Number(src.nbFolders) > 0;
        })
        .map((expert) => {
          const src =
            (expert.dataGeneral &&
              expert.dataGeneral[datasetKey] &&
              expert.dataGeneral[datasetKey][1]) ||
            {};
          const row = { Expert: expert.name, Agence: expert.agencyName };
          labels.forEach((label) => {
            row[label.name] = src[label.id] != null ? src[label.id] : "";
          });
          return row;
        });
    this.exportWorkbook(
      [
        { name: "Réparables", rows: buildRows(getReparableLabelsList(), "R") },
        {
          name: "Non réparables",
          rows: buildRows(getUnreparableLabelsList(), "NR"),
        },
      ],
      "compagnie_par_expert"
    );
  };

  handleExportByAgency = () => {
    const agencies = this.props.dataByAgency || [];
    if (!agencies.length) return;
    const buildRows = (labels, datasetKey) => {
      const visibleAgencies = agencies.filter((agency) => {
        const src =
          agency.dataGeneral &&
          agency.dataGeneral[datasetKey] &&
          agency.dataGeneral[datasetKey][1];
        return src && Number(src.nbFolders) > 0;
      });
      return labels.map((label) => {
        const row = { Indicateur: label.name };
        visibleAgencies.forEach((agency) => {
          const src =
            (agency.dataGeneral &&
              agency.dataGeneral[datasetKey] &&
              agency.dataGeneral[datasetKey][1]) ||
            {};
          row[agency.name] = src[label.id] != null ? src[label.id] : "";
        });
        return row;
      });
    };
    this.exportWorkbook(
      [
        { name: "Réparables", rows: buildRows(getReparableLabelsList(), "R") },
        {
          name: "Non réparables",
          rows: buildRows(getUnreparableLabelsList(), "NR"),
        },
      ],
      "compagnie_par_agence"
    );
  };

  exportAction = <FontAwesomeIcon icon={faFileExcel} title="Exporter en Excel" />;

  filters = () => {
    if (parseInt(this.props.company) === 1) {
      // ALLIANZ
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP</p>
            <p>
              nature evenement : exclure événement climatique et vol non
              retrouvé
            </p>
            <p>réparations Ecrêtement : 20 à 10 000€ TTC</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP</p>
            <p>
              nature evenement : exclure événement climatique et vol non
              retrouvé
            </p>
            <p>nature expertise: inclure "I" et "3"</p>
            <p>VRADE Ecrêtement : 20 à 10 000€ TTC</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 2) {
      // COVEA
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : hors CATNAT</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : hors CATNAT</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 2) {
      // COVEA
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (
      parseInt(this.props.company) === 10 ||
      parseInt(this.props.company) === 11
    ) {
      // GAN - GROUPAMA
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE</p>
            <p>
              nature evenement : circulation, incendie, stationnement, vol et
              vandalisme
            </p>
            <p>nature expertise: exclure "I" et "3"</p>
            <p>réparations Ecrêtement : 230 € à 3 210 € HT</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE</p>
            <p>
              nature evenement : circulation, incendie, stationnement, vol et
              vandalisme
            </p>
            <p>nature expertise: inclure "I" et "3"</p>
            <p>VRADE Ecrêtement : 604 € à 8 958 € HT</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 3) {
      // MACIF
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>couts réparables :</p>
            <p>genre : VP CTTE</p>
            <p>nature évenement : circulation et stationnement</p>
            <p>nature expertise: exclure "I"</p>
            <p>
              réparations Ecrêtement : 21 € à 4 000 € HT / 21 € à 35 000 € HT
            </p>
            <p>Délai : </p>
            <p>tous les dossiers</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>Cout VRADE :</p>
            <p>genre : VP CTTE</p>
            <p>nature évenement : circulation et stationnement</p>
            <p>nature expertise: inclure "I"</p>
            <p>VRADE Ecrêtement : 100 € à 12 000 € TTC / 0 € à 35 000 € TTC </p>
            <p>Délai : </p>
            <p>tous les dossiers</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 8) {
      // MAIF
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>Cout réparable :</p>
            <p>Nature d'évènement : D à D4, E à E4, Fà F6, H à H8 et J</p>
            <p>Nature expertise : NORMALE</p>
            <p>Genre : VP et CTTE</p>
            <p>Réparation : Montant HT</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>Cout VRADE :</p>
            <p>Nature d'évènement : D à D4, E à E4, Fà F6, H à H8 et J</p>
            <p>Nature expertise : RIV, VEI</p>
            <p>Genre : VP et CTTE</p>
            <p>Réparation : Montant HT</p>
            <p>
              {
                "VRADE : véhicules < 10 ans - 1 000 à 8 500 € HT ou véhicules >= 10 ans - 0 à 5 000 € HT"
              }
            </p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 9) {
      // MATMUT
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : Collision, stationnement, vol et incendie</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : Collision, stationnement, vol et incendie</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 20) {
      // AXA
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : exclure évènements climatiques et vol</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : exclure évènements climatiques et vol</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 13) {
      // ABEILLE
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : exclure évènements climatiques et vol</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>nature évènement : exclure évènements climatiques et vol</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 5) {
      // ACM
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>réparations entre 200 € et 4 600 € HT</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>VRADE Ecrêtement 0 € à 13 000 € HT</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else if (parseInt(this.props.company) === 18) {
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>réparations {">"} 20 € HT HT</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>VRADE {">"} 20 € HT</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    } else {
      if (this.props.tabsIndex === 1) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>réparations {">"} 20 € HT HT</p>
            <p>nature expertise: exclure "I" et "3"</p>
          </div>
        );
      } else if (this.props.tabsIndex === 2) {
        return (
          <div style={{ fontSize: "10px" }}>
            <p>genre : VP CTTE </p>
            <p>VRADE {">"} 20 € HT</p>
            <p>nature expertise: inclure "I" et "3"</p>
          </div>
        );
      }
    }
  };

  getChart = (
    data,
    title,
    name,
    format,
    height = undefined,
    isLarge = false,
    dataN1 = null
  ) => {
    const dataSet = [
      {
        type: "line",
        data: data[name],
        label: "Isolé",
        color: "green",
      },
      {
        type: "line",
        data: data[`${name}_cumul`],
        label: "Cumulé",
        color: "red",
      },
    ];

    // Ajouter les courbes N-1 si les données existent
    if (dataN1 && dataN1[name]) {
      dataSet.push({
        type: "line",
        data: dataN1[name],
        label: "Isolé N-1",
        color: "#90EE90", // vert clair
        borderDash: [5, 5],
      });
    }
    if (dataN1 && dataN1[`${name}_cumul`]) {
      dataSet.push({
        type: "line",
        data: dataN1[`${name}_cumul`],
        label: "Cumulé N-1",
        color: "#FFCCCB", // rouge clair
        borderDash: [5, 5],
      });
    }

    return (
      <Col xs={12} md={isLarge ? 12 : 6}>
        <BarChart
          title={title}
          format={format}
          height={height}
          dataSet={dataSet}
          isLegend={true}
          yAxes={[
            {
              display: true,
            },
          ]}
        />
      </Col>
    );
  };

  getChart2 = (dataSet, title, isLegend = true, isLarge = false) => {
    return (
      <Col xs={12} md={isLarge ? 12 : 6}>
        <BarChart
          title={title}
          format={"percentage"}
          dataSet={dataSet}
          isLegend={isLegend}
          yAxes={[
            {
              display: true,
            },
          ]}
          height={350}
        />
      </Col>
    );
  };

  render() {
    const filters = this.filters();
    const colors = getColors();

    const chartR = [
      {
        title: "Cout moyen réparable",
        name: "averageCost",
        format: "currency",
      },
      {
        title: "Cout moyen Pièces",
        name: "piecesCostGlobal",
        format: "currency",
      },
      { title: "Nombre heures", name: "totalHourGlobal" },
      { title: "Nombre heures peinture ", name: "totalHourPaintGlobal" },
      {
        title: "Tx de dossier avec au moins une PRE",
        name: "PREGlobal",
        format: "percentage",
      },
      {
        title: "Tx de dossier avec au moins une RP",
        name: "RPGlobal",
        format: "percentage",
      },
      {
        title: "Tx de dossier avec au moins une PQE",
        name: "PQEGlobal",
        format: "percentage",
      },
      { title: "Délai mission-depot", name: "missionDepotGlobal" },
      { title: "Âge véhicule", name: "ageVehicleGlobal" },
      {
        title: "Taux EAD/SELFCARE (%)",
        name: "EADGlobal",
        format: "percentage",
      },
      { title: "Précisia", name: "predict", isLarge: true },
    ];

    const chartNR = [
      { title: "Cout moyen VRADE", name: "VRADE", format: "currency" },
      { title: "Délai SD29", name: "missionSD29Global" },
      { title: "Délai mission dépot", name: "missionDepotGlobal" },
      { title: "Taux de VEI", name: "VEI", format: "percentage" },
      {
        title: "Prix à neuf avec options HT",
        name: "vehicleTotalPriceDutyFree",
        format: "currency",
      },
      { title: "Kilométrage moyen", name: "averageMileage" },
      {
        title: "Taux de correctif selon marché HT dans bilan technique",
        name: "correctiveRateTechnicalReport",
        format: "percentage",
      },
      {
        title: "Taux de +/- values HT dans bilan technique",
        name: "resultTechnicalReportDutyFree",
        format: "percentage",
      },
      { title: "Âge véhicule", name: "ageVehicleGlobal" },
      { title: "Précisia", name: "predict" },
    ];

    return (
      <FadeIn>
        <TabsCustom>
          <TabsCustomHeader>
            {this.state.tabsMenu.map((element, idx) => (
              <TabsCustomMenu
                key={idx}
                title={element}
                active={this.props.tabsIndex === idx}
                disabled={!this.state.tabsData[idx]}
                onClick={(e) => {
                  this.state.tabsData[idx] && this.props.onChangeTab(idx);
                }}
              />
            ))}
          </TabsCustomHeader>
          <TabsCustomBody noCard>
            {this.state.tabsMenu.map((element, idx) => (
              <TabsCustomItem key={idx} active={this.props.tabsIndex === idx}>
                {this.props.tabsIndex === 0 ? (
                  <GeneralCharts
                    data={this.props.dataChart && this.props.dataChart}
                    isPrint={this.props.isPrint}
                  />
                ) : this.props.tabsIndex === 1 ? (
                  <>
                    <Card title="Graphiques" className="mb-20">
                      <Row>
                        {chartR.map((chart) =>
                          this.getChart(
                            this.props.data.chartR,
                            chart.title,
                            chart.name,
                            chart.format,
                            undefined,
                            chart.isLarge,
                            this.props.data.chartR_N1
                          )
                        )}
                      </Row>
                    </Card>
                    <Card title="Tableau">
                      {filters}
                      <TableReparable
                        data={this.props.data && this.props.data.R}
                        company={this.props.company}
                        performanceAgency={this.props.performanceAgency}
                        updatePerformanceAgency={
                          this.props.updatePerformanceAgency
                        }
                        leaveUpdatePerformanceAgency={
                          this.props.leaveUpdatePerformanceAgency
                        }
                      />
                    </Card>
                  </>
                ) : this.props.tabsIndex === 2 ? (
                  <>
                    <Card title="Graphiques" className="mb-20">
                      <Row>
                        {chartNR.map((chart) =>
                          this.getChart(
                            this.props.data.chartNR,
                            chart.title,
                            chart.name,
                            chart.format,
                            undefined,
                            false,
                            this.props.data.chartNR_N1
                          )
                        )}
                      </Row>
                    </Card>
                    <Card title="Tableau">
                      {filters}
                      <TableUnreparable
                        data={this.props.data && this.props.data.NR}
                        company={this.props.company}
                        performanceAgency={this.props.performanceAgency}
                        updatePerformanceAgency={
                          this.props.updatePerformanceAgency
                        }
                        leaveUpdatePerformanceAgency={
                          this.props.leaveUpdatePerformanceAgency
                        }
                      />
                    </Card>
                  </>
                ) : this.props.tabsIndex === 3 ? (
                  <Card>
                    <TableQuality
                      data={this.props.data && this.props.data.quality}
                      company={this.props.company}
                      performanceAgency={this.props.performanceAgency}
                      updatePerformanceAgency={
                        this.props.updatePerformanceAgency
                      }
                      leaveUpdatePerformanceAgency={
                        this.props.leaveUpdatePerformanceAgency
                      }
                    />
                  </Card>
                ) : this.props.tabsIndex === 4 ? (
                  <>
                    <Card title="Graphiques" className="mb-20">
                      <Row>
                        {this.getChart(
                          this.props.data.chartR,
                          `${chartR[4].title} ${
                            !this.props.group ? "Réseau" : ""
                          }
                          ${
                            this.props.group && !this.props.region
                              ? "Groupe"
                              : ""
                          }
                          ${
                            this.props.region && !this.props.agency.length
                              ? "Région"
                              : ""
                          }
                          ${
                            this.props.agency.length === 1 && !this.props.expert
                              ? "Agence"
                              : ""
                          } ${this.props.expert ? "Expert" : ""}`,
                          chartR[4].name,
                          chartR[4].format,
                          350,
                          false,
                          this.props.data.chartR_N1
                        )}
                        {this.props.region
                          ? null
                          : this.getChart2(
                              Object.keys(this.props.data.chartPRE.region).map(
                                (key, idx) => {
                                  return {
                                    type: "line",
                                    data: this.props.data.chartPRE.region[key]
                                      .data,
                                    label:
                                      this.props.data.chartPRE.region[key].name,
                                    color: colors[idx],
                                  };
                                }
                              ),
                              "Taux de PRE / région"
                            )}
                        {this.props.agency.length === 1
                          ? null
                          : this.getChart2(
                              Object.keys(this.props.data.chartPRE.agency).map(
                                (key) => {
                                  return {
                                    type: "line",
                                    data: this.props.data.chartPRE.agency[key]
                                      .data,
                                    label:
                                      this.props.data.chartPRE.agency[key].name,
                                    color:
                                      this.props.data.chartPRE.agency[key]
                                        .color,
                                  };
                                }
                              ),
                              "Taux de PRE / agence"
                            )}
                        {this.props.user
                          ? null
                          : this.getChart2(
                              Object.keys(this.props.data.chartPRE.expert).map(
                                (key) => {
                                  return {
                                    type: "line",
                                    data: this.props.data.chartPRE.expert[key]
                                      .data,
                                    label:
                                      this.props.data.chartPRE.expert[key].name,
                                    color:
                                      this.props.data.chartPRE.expert[key]
                                        .color,
                                  };
                                }
                              ),
                              "Taux de PRE / expert",
                              false,
                              this.props.region &&
                                this.props.agency.length !== 1
                            )}
                      </Row>
                    </Card>
                    <Card title="Tableau">
                      <TablePRE
                        data={this.props.data && this.props.data.R}
                        company={this.props.company}
                        performanceAgency={this.props.performanceAgency}
                        updatePerformanceAgency={
                          this.props.updatePerformanceAgency
                        }
                        leaveUpdatePerformanceAgency={
                          this.props.leaveUpdatePerformanceAgency
                        }
                      />
                    </Card>
                  </>
                ) : this.props.tabsIndex === 5 ? (
                  <Card
                    title="Compagnie par Expert"
                    action={this.exportAction}
                    onClick={this.handleExportByExpert}
                  >
                    <TableByExpert data={this.props.dataByExpert || []} />
                  </Card>
                ) : this.props.tabsIndex === 6 ? (
                  <Card
                    title="Compagnie par agence"
                    action={this.exportAction}
                    onClick={this.handleExportByAgency}
                  >
                    <TableByAgency data={this.props.dataByAgency || []} />
                  </Card>
                ) : null}
              </TabsCustomItem>
            ))}
          </TabsCustomBody>
        </TabsCustom>
      </FadeIn>
    );
  }
}

export default GeneralData;
